import { useId } from 'react';

type Props = {
  className?: string;
  off?: boolean;
  // больше одной камеры: корпус залит, цифра выбита маской — читается на любом фоне и в 20px
  count?: number;
};

export function CameraIcon({ className, off, count }: Props) {
  const id = useId();
  const digit = count && count > 1 ? count : null;
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      {digit && (
        <mask id={id}>
          <rect x="0" y="0" width="24" height="24" fill="#fff" />
          <text
            x="8.5"
            y="15.5"
            textAnchor="middle"
            fontSize="10"
            fontWeight="700"
            fontFamily="var(--font-inter), sans-serif"
            fill="#000"
            stroke="none"
          >
            {digit}
          </text>
        </mask>
      )}
      <polygon points="23 7 16 12 23 17 23 7" />
      <rect
        x="1"
        y="5"
        width="15"
        height="14"
        rx="2"
        ry="2"
        fill={digit ? 'currentColor' : undefined}
        mask={digit ? `url(#${id})` : undefined}
      />
      {off && <line x1="2" y1="2" x2="22" y2="22" />}
    </svg>
  );
}
